import { enMessages } from './locales/en_US';
import { esMessages } from './locales/es_ES';
import { ptMessages } from './locales/pt_PT';

export const messages: Record<string, any> = {
  en: enMessages,
  es: esMessages,
  pt: ptMessages,
};